var OccurenceType = /** @class */ (function () {
    function OccurenceType(id, name) {
        this.id = id;
        this.name = name;
    }
    return OccurenceType;
}());
export { OccurenceType };
